class KeypadCanvasUI {
	selectedKeypadId = $state<number | null>(null);
	selectedKeyId = $state<number | null>(null);
	showSceneForm = $state(false);
	showRenameForm = $state(false);

	reset() {
		this.selectedKeypadId = null;
		this.selectedKeyId = null;
		this.showSceneForm = false;
		this.showRenameForm = false;
	}
}

export const keypadCanvasUI = new KeypadCanvasUI();
